import Link, { LinkProps as MUILinkProps } from "@mui/material/Link";
import { FC, PropsWithChildren } from "react";


export type InternalLinkProps = PropsWithChildren<MUILinkProps>;

export const InternalLink: FC<InternalLinkProps> = ({
	children,
	...rest
}) => {
	return (
		<Link underline="none" {...rest}>
			{children}
		</Link>
	);
};
